import React from 'react';
import { MaskedValue } from '../types/SC5Report';

export interface NumberFormatterProps {
  children: MaskedValue | number | JSX.Element;
  mask?: number;
}

export const NumberFormatter = ({ mask, children }: NumberFormatterProps): JSX.Element => {
  // plain number
  if (typeof children === 'number') {
    if (children > 0 && mask && children < mask) {
      return <span>Less than {mask}</span>;
    }
    const formattedValue = new Intl.NumberFormat('es-US', {
      style: 'decimal',
    }).format(children);
    return <span>{formattedValue}</span>;
  }
  // cust_a object
  if (typeof children === 'object') {
    const maskObj = children as MaskedValue;
    if (typeof maskObj.mask === 'number') { // value probably masked
      if (maskObj.val < maskObj.mask) {
        return <span>Less than ${maskObj.mask}</span>;
      }
    }
    const formattedValue = new Intl.NumberFormat('es-US', {
      style: 'decimal',
    }).format(maskObj.val);
    return <span>{formattedValue}</span>;
  }

  return children;
};

export default NumberFormatter;
